import { ContactRoles, removeContactRoles } from './removeContactRoles'

interface IHandleRelinkingRemovingRoles {
  targetsContactsWithRoleForRemoving: ContactRoles[]
}
export const handleRelinkingRemovingRoles = async ({
  targetsContactsWithRoleForRemoving,
}: IHandleRelinkingRemovingRoles) => {
  await removeContactRoles(targetsContactsWithRoleForRemoving)
}
